namespace AgerLMS.LMS {
    export interface FinishQuizRequest extends Serenity.ServiceRequest {
        Quiz?: QuizRow;
        UserAnswers?: { [key: number]: number };
        Attempt?: number;
    }
}
